'use client';

import { motion, useReducedMotion, type HTMLMotionProps } from 'framer-motion';
import type { ReactNode } from 'react';

interface FadeInProps extends HTMLMotionProps<'div'> {
  children: ReactNode;
  delay?: number;
  /** Distancia de traslación en px desde abajo. */
  y?: number;
  /** Duración en ms. Default: editorial 720ms. */
  duration?: number;
  once?: boolean;
}

/**
 * FadeIn — primitivo de animación de entrada.
 * Fade + translateY al entrar al viewport. Respeta prefers-reduced-motion (no-op).
 */
export function FadeIn({
  children,
  delay = 0,
  y = 16,
  duration = 720,
  once = true,
  ...motionProps
}: FadeInProps) {
  const reduced = useReducedMotion();
  if (reduced) {
    return (
      <div className={motionProps.className} id={motionProps.id}>
        {children}
      </div>
    );
  }
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '0px 0px -10% 0px' }}
      transition={{
        duration: duration / 1000,
        delay: delay / 1000,
        ease: [0.22, 1, 0.36, 1],
      }}
      {...motionProps}
    >
      {children}
    </motion.div>
  );
}
